export default "__VITE_ASSET__BvaNxU71__"